import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { PortalDAO } from "../../daos/portal.dao";
import { LandingComponent } from "./landing.component";
import { TranslocoRootModule } from '../../i18n/transloco-root.module';
import { ButtonModule } from "primeng/button";
import { ToastModule } from 'primeng/toast';
import { RippleModule } from "primeng/ripple";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        TranslocoRootModule,
        ButtonModule,
        ToastModule,
        RippleModule
    ],
    declarations: [
        LandingComponent
    ],
    exports: [
        LandingComponent
    ],
    providers: [
        PortalDAO
    ]
})
export class LandingModule {
}
